export default {
  'loading.title': '正在加载资源',
  'loading.subtitle': '请稍候...',
  'loading.initial.title': '正在加载资源',
  'loading.initial.subtitle': '初次加载资源可能需要较多时间 请耐心等待',
};
